/*
 * Sidebar Alpine.js Component
 * Manages sidebar collapse/expand, mobile toggle, and menu accordion
 */

function sidebar() {
    return {
        collapsed: sessionStorage.getItem('sidebar-collapsed') === 'true',
        mobileOpen: false,
        activeSection: null,

        init() {
            // Set initial active section from server-rendered data attribute
            this.activeSection = this.$el.dataset.activeArea || null;

            // Remove pre-Alpine collapsed class — Alpine handles all state now
            document.documentElement.classList.remove('sidebar-is-collapsed');

            // Enable transitions after initial paint to prevent layout shift
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    document.body.classList.add('sidebar-ready');
                });
            });

            // Close mobile sidebar on resize to desktop
            window.addEventListener('resize', () => {
                if (window.innerWidth >= 992) {
                    this.mobileOpen = false;
                }
            });
        },

        toggleSection(name) {
            this.activeSection = this.activeSection === name ? null : name;
        },

        toggleSidebar() {
            if (window.innerWidth < 992) {
                this.mobileOpen = !this.mobileOpen;
            } else {
                this.collapsed = !this.collapsed;
                sessionStorage.setItem('sidebar-collapsed', this.collapsed);
            }
        },

        closeMobile() {
            this.mobileOpen = false;
        }
    };
}